import { useEffect, useState } from 'react';

import useWindowSize from './useWindowSize';

const useViewportSize = () => {
  const [vw, setVw] = useState<string>();
  const [vh, setVh] = useState<string>();

  const { outerWidth, outerHeight } = useWindowSize();

  useEffect(() => {
    const { userAgent } = window.navigator;
    const isMobile =
      /mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) &&
      !/iPad/i.test(userAgent);

    if (isMobile) {
      setVw(outerWidth ? `${outerWidth / 100}px` : '1lvw');
      setVh(outerHeight ? `${outerHeight / 100}px` : '1lvh');
    } else {
      setVw('1vw');
      setVh('1vh');
    }
  }, [outerWidth, outerHeight]);

  return { vw, vh };
};

export default useViewportSize;
